<div class="flex flex-col gap-4 pt-4">
  <section class="flex items-baseline justify-around">
    <h2 class="text-2xl font-bold">Timesheet Manager</h2>
    <wedate-input [dateHandler]="handler" [hasIncrementors]="true" (weDateChanged)="handleWeDateChange()" />

    <div>
      <mat-form-field [hideRequiredMarker]="true">
        <mat-label>Add Cost Center</mat-label>
        <input
          type="number"
          min="1"
          placeholder="123456"
          matInput
          [formControl]="costCenterFormCtrl"
          (blur)="resetCostCenterValidationIfEmpty()"
          (keyup.enter)="addCostCenterTab()"
        />
        <mat-hint>
          @if (retrievedCostCenterInfo) {
            <span>{{ retrievedCostCenterInfo.Description }}</span>
          } @else {
            <span>&nbsp;</span>
          }
        </mat-hint>
        @if (costCenterFormCtrl.errors?.['required'] || costCenterFormCtrl.errors?.['pattern']) {
          <mat-error> Must be 6 numbers </mat-error>
        }
        @if (costCenterFormCtrl.errors?.['costCenterDoesNotExist']) {
          <mat-error>Invalid cost center</mat-error>
        }
      </mat-form-field>
      <button
        type="button"
        class="!ml-2"
        mat-raised-button
        [disabled]="costCenterFormCtrl.invalid || !retrievedCostCenterInfo"
        (click)="addCostCenterTab()"
      >
        @if (isRetrievingCostCenterName) {
          <mat-spinner diameter="20" class="mr-2 !inline-block" />
        } @else {
          <span>Add</span>
        }
      </button>
    </div>
  </section>

  @if (isSearchingForCostCenter) {
    <div class="flex min-h-[300px] items-center justify-center">
      <mat-spinner />
    </div>
  } @else {
    <div class="flex w-full flex-row justify-start gap-1">
      @if (customerGrpsInSearch.length > 0) {
        <div class="mx-1 mt-16 border-r-[1px] border-[lightgray] pr-1">
          <tabs
            tabWidth="65px"
            class="timesheet-side-tabs"
            layout="col"
            [tabs]="customerGrpsInSearch"
            [active]="currentCustomerGrpIndex"
            (tabChanged)="handleTabChange($event)"
          />
        </div>
      }
      <div class="mr-3 min-h-[300px] w-full" [class.ml-3]="customerGrpsInSearch.length <= 0">
        <tabs
          displayProperty="value.CustomerName"
          displayProperty2="value.CostCenterDisplay"
          closeButtonProperty="value.shouldHideCloseButton"
          class="timesheet-top-tabs"
          tabType="multiLine"
          layout="row"
          tabWidth="150px"
          [tabs]="conditionsInSearch"
          (tabChanged)="handleTabChange($event)"
          (removeTab)="removeCostCenterTab($event)"
          (setHorizontalTabsConfigs)="getHorizontalTabConfigs($event)"
        />
        <table-like-layout
          configPath="__config"
          [config]="config"
          [values]="timesheets"
          [shouldHideTotal]="true"
          (iconClicked)="handleIconClicked($event)"
          (plainButtonClicked)="handlePlainButtonClicked($event)"
          (valueChanged)="handleValueChanged($event)"
        />
      </div>
    </div>
  }

  <section class="flex items-center justify-between">
    <div class="w-1/3"></div>
    <div class="w-1/3 text-center">
      @if (doesContainAnyContractsExpiringSoon) {
        <div class="mb-4 text-red-600">
          <strong>Contract will expire within two weeks!</strong>
        </div>
      }
      <button
        mat-raised-button
        color="primary"
        [disabled]="shouldDisableAddTimesheet || isSearchingForCostCenter"
        (click)="addNewTimesheet()"
      >
        @if (isCreatingTimesheet) {
          <mat-spinner diameter="20" class="mr-2 !inline-block" />
          <span>Adding&hellip;</span>
        } @else {
          <span>Add New Timesheet</span>
        }
      </button>
    </div>
    <div class="w-1/3 pr-3 text-right text-gray-600">*Changes are saved automatically.</div>
  </section>
</div>
